export default "__VITE_ASSET__C23ZMwQH__"